import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource, Query } from 'utility-ts-orm';
import { Contact } from '../builders/contact_builder';
import { ContactsSearchModel } from '../models/contacts_search_model';
import { ContactSearchService } from '../services/contact_search_service';

export class ContactsSearchQuery implements IQuery {
  private _result: Contact[];

  constructor(
    private ngContactsSearchModel: ContactsSearchModel,
    private ngContactsDatastore: IDatasource<Contact>,
    private ngContactSearchService: ContactSearchService
  ) {
    Query.registerQuery(this, this.ngContactsSearchModel);
  }

  clear() {
    this._result = [];
  }

  run(): this {
    const { searchTerm } = this.ngContactsSearchModel.read();
    this.ngContactSearchService.search(searchTerm);
    this._result = this.ngContactSearchService.allResults;
    return this;
  }

  get result() {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/queries/contacts_search_query.ts